import React, { lazy, Suspense } from "react";

const LazyReScurityList = lazy(() => import("./ReScurityList"));
const LazyPrintListScurety = lazy(() => import("./PrintListScurety"));
const LazyPrintListTakeMoney = lazy(() => import("./PrintListTakeMoney"));
const LazyPrintListparadan = lazy(() => import("./PrintListparadan"));
const LazyReListParadan = lazy(() => import("./ReListParadan"));
const LazyReListTakeMoney = lazy(() => import("./ReListTakeMoney"));
const LazyReListWriteForm = lazy(() => import("./ReListWriteForm"));
const LazyView_Scurety_component = lazy(() =>
  import("./ViewAllBills/View_Scurety_component")
);
export const PrintListparadan = () => (
  <Suspense fallback="loading...">
    <LazyPrintListparadan />
  </Suspense>
);
export const View_Scurety_component = () => (
  <Suspense fallback="loading...">
    <LazyView_Scurety_component />
  </Suspense>
);
export const ReScurityList = () => (
  <Suspense fallback="loading...">
    <LazyReScurityList />
  </Suspense>
);

export const PrintListTakeMoney = () => (
  <Suspense fallback="loading...">
    <LazyPrintListTakeMoney />
  </Suspense>
);

export const ReListParadan = () => (
  <Suspense fallback="loading...">
    <LazyReListParadan />
  </Suspense>
);

export const ReListTakeMoney = () => (
  <Suspense fallback="loading...">
    <LazyReListTakeMoney />
  </Suspense>
);

export const ReListWriteForm = () => (
  <Suspense fallback="loading...">
    <LazyReListWriteForm />
  </Suspense>
);

export const PrintListScurety = () => (
  <Suspense fallback="loading...">
    <LazyPrintListScurety />
  </Suspense>
);
